import _ from "underscore";
import { ApiProject } from "avvir";

import Project from "../../models/domain/project";

export default class ProjectConverter {
  static fromApi = (apiProject: Partial<ApiProject>): Partial<Project> => {
    const {
      city,
      country,
      addressLine1,
      addressLine2,
      state,
      zip,
      defaultFirebaseFloorId,
      endDate,
      firebaseId,
      name,
      notes,
      pricing,
      startDate,
      bimVersionDate,
      firebaseFloorIds,
      systemOfMeasurement,
      archivedAt,
      progressNotes,
      avvirAnalysisNotes,
      sourceAnalysisNotes,
      id,
      clientAccountId: organizationId,
      scannedProjectMasterformatProgresses,
      baselineProjectMasterformatProgresses,
      currentProjectMasterformatProgresses,
      costAnalysisProgresses,
      projectReports,
      generateMasterformatProgressEnabled,
      integrationProjectId,
      settings,
      baselineScheduleDate,
      currentScheduleDate,
      isLocked
    } = apiProject;
    const converted = _.omit({
      ...new Project({
        addressCity: city,
        addressCountry: country,
        addressLine1,
        addressLine2,
        addressState: state,
        addressZip: zip,
        defaultFirebaseFloorId,
        endDate,
        firebaseId,
        name,
        notes,
        pricing,
        startDate,
        bimVersionDate,
        firebaseFloorIds,
        systemOfMeasurement,
        archivedAt,
        progressNotes,
        avvirAnalysisNotes,
        sourceAnalysisNotes,
        id,
        firebaseOrganizationId: organizationId,
        scannedProjectMasterformatProgresses,
        baselineProjectMasterformatProgresses,
        currentProjectMasterformatProgresses,
        // @ts-ignore
        costAnalysisProgresses,
        projectReports,
        generateMasterformatProgressEnabled,
        integrationProjectId,
        settings: settings,
        baselineScheduleDate,
        currentScheduleDate,
        isLocked
      })
    }, (value) => !value) as Partial<Project>;
    // `isLocked` is a meaningful boolean: a `false` (unlocked) value must survive so a later load of an
    // unlocked project can clear a previously-locked state. _.omit strips every falsy value, so restore
    // it explicitly whenever the API response actually carried a boolean.
    if (typeof isLocked === "boolean") {
      converted.isLocked = isLocked;
    }
    // _.omit strips the null, and the projects reducer merges over the project it already holds, so
    // dropping the key leaves a cleared date in the store.
    if ("bimVersionDate" in apiProject && apiProject.bimVersionDate == null) {
      converted.bimVersionDate = null;
    }
    return converted;
  };

  static toApiProject(project: Partial<Project>): ApiProject {
    const {
      addressCity: city,
      addressCountry: country,
      addressState: state,
      addressZip: zip,
      files,
      photoAreas,
      masterformatProgress,
      firebaseOrganizationId: clientAccountId,
      generateMasterformatProgressEnabled,
      ...restOfProject
    } = project;
    const apiProject = new ApiProject({ city, country, state, zip, clientAccountId, generateMasterformatProgressEnabled, ...restOfProject });
    // The api reads a missing bimVersionDate as "leave the saved one alone" and a null one as "clear
    // it". ApiProject's date mixin only assigns truthy values, so a cleared date arrives as undefined
    // and JSON.stringify drops the key -- saying "leave it alone" when the user asked to remove it.
    // Assigning after construction puts the key back, carrying the null.
    if ("bimVersionDate" in project && project.bimVersionDate == null) {
      apiProject.bimVersionDate = null;
    }
    return apiProject;
  }
}
